import React, { useEffect, useRef } from 'react';
import { getClientLogos } from '../mockData';

const ClientLogoSlider = () => {
  const logos = getClientLogos();
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer || logos.length === 0) return;

    let animationFrameId;
    let scrollPosition = 0;

    const animate = () => {
      scrollPosition += 0.5;
      if (scrollPosition >= scrollContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }
      scrollContainer.scrollLeft = scrollPosition;
      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [logos.length]);

  if (logos.length === 0) {
    return null;
  }

  // Duplicate logos for seamless loop
  const duplicatedLogos = [...logos, ...logos, ...logos];

  return (
    <div className="w-full overflow-hidden bg-gradient-to-r from-[#F5F7FA] via-white to-[#F5F7FA] py-6">
      <div
        ref={scrollRef}
        className="flex space-x-12 overflow-x-hidden"
        style={{ scrollBehavior: 'auto' }}
      >
        {duplicatedLogos.map((logo, index) => (
          <div
            key={`${logo.name}-${index}`}
            className="flex-shrink-0 flex items-center justify-center px-6 opacity-60 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0"
          >
            <img
              src={logo.logo}
              alt={logo.name}
              className="h-16 w-auto object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientLogoSlider;